/**
 * Quill leaves markup like `<p><br></p>` in an emptied editor. Images and
 * embeds count as content.
 */
export function isRichTextEmpty(html) {
    if (!html) {
        return true;
    }
    if (/<(img|iframe|video)\b/i.test(html)) {
        return false;
    }
    return (html
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .trim() === '');
}
